export var submenuIndicatorDirection = function submenuIndicatorDirection(vertical) {
  return vertical ? {} : {
    transform: "rotate(90deg)"
  };
};